import React, { Component } from 'react';
import Input from '../../../node_modules/react-bootstrap/lib/Input';
import TouchButton from '../TouchButton';

const ExerciseNumericInput = React.createClass({

    getInitialState: function() {
        return {attempt: ''};
    },

    handleInputChange: function(e) {
        this.setState({attempt: e.target.value})
    },

    onSubmitHandler: function(e) {
        e.preventDefault();
        const attempt = this.state.attempt.trim();
        if(!attempt) {
            return;
        }

        this.props.onInputSubmit(attempt);

        // Clear inputs after the submit
        this.setState({attempt: ''});
    },

    render: function () {

        return (
            <form className="exercise-answer-area" onSubmit={this.onSubmitHandler}>
                <div className="exercise-answer-area--input">
                    <Input
                        type="text"
                        value={this.state.attempt}
                        placeholder="Skriv din lösning här och tryck enter..."
                        size="80"
                        onChange={this.handleInputChange}
                    />
                    <div className="exercise-answer-area--buttons">
                        <TouchButton className="answer-button">+</TouchButton>
                        <TouchButton className="answer-button">( )</TouchButton>
                        <TouchButton className="answer-button"><span className="mathSymbol square"><span>a</span></span></TouchButton>
                        <TouchButton className="answer-button">a<sup>b</sup></TouchButton>
                        <TouchButton className="answer-button"><span className="mathSymbol">&pi;</span></TouchButton>

                    </div>
                </div>
            </form>
        );
    }

});


export default ExerciseNumericInput;


/** WEBPACK FOOTER **
 ** ./src/components/ExerciseNumericInput/ExerciseNumericInput.js
 **/